import React from "react"
import MissingComponent from "components/missing-component"
import {
  omit
} from "utils"

/**
 * Handle null values from backend as undefined to make default assignment work proerly
 */
export const nullCheckProps = (props) => {
  const newProps = props
  Object.entries(props).forEach(([key, val]) => {
    if (val === null) {
      newProps[key] = undefined // change all null values to undefined
    }
  })
  return newProps
}

/**
 * Constructs transformed output props excluding inputs.
 * Executes outputFunc on each input-output mapping.
 */
export const constructOutputProps = (
  props,
  mapInputToOutput = [
    ["components", "children"]
  ],
  outputFunc = outputProps => outputProps,
  initialProps = {}
) => ({
  ...omit(mapInputToOutput.reduce((prev, [input]) => [...prev, input], []), props),
  ...mapInputToOutput.reduce(
    (prev, [input, output]) => ({
      ...prev,
      [output]: outputFunc(props[input])
    }),
    initialProps
  )
})

export const getComponentDisplayName = Component =>
  Component.displayName || Component.name || "Component"

export const matchComponentName = (name, list) =>
  list.find(comp => getComponentDisplayName(comp) === name) || // Try first to derive exact component name
  list.find(comp => getComponentDisplayName(comp).indexOf(`(${name})`) > -1) // try next partial match - this occurs when a component is wrapped in HOCs

/**
 * Constructs transformed output props excluding inputs.
 */
export const jsonToComponents = (
  componentWhitelist,
  mapInput = comp => comp,
  wrappedComponentName = "wrappedComponent"
) => (json = []) => {
  if (json == null) return null
  return json.map(mapInput).map(({
    name,
    props
  }, index) => {
    const components =
      typeof componentWhitelist === "object"
        ? Object.values(componentWhitelist)
        : componentWhitelist

    if (components.some(Comp => typeof Comp === "undefined")) {
      throw Error(`Some componentWhitelist items are undefined for ${
        wrappedComponentName
      } component. Check your imports.`)
    }
    const Component = matchComponentName(name, components)

    const newProps = props
    Object.entries(props).forEach(([key, val]) => {
      if (val === null) {
        newProps[key] = undefined // change all null values to undefined
      }
    })

    if (!Component) {
      console.error(`"${name}" component was not found in componentWhitelist for ${wrappedComponentName}.`)
      return (<MissingComponent {...nullCheckProps(props)} key={index} expectedComponentName={name} />
      )
    }
    return (<Component key={index} {...nullCheckProps(props)} />)
  })
}



// WEBPACK FOOTER //
// ./src/utils/component.js